





















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import { GETTER_INS_USER_INFO_LIST } from "@/store/constants/ins_user_info_types";
import { GETTER_CURRENT_USER_ID } from "@/store/constants/index_types";
import Scroller from "@/components/Scroller/Scroller.vue";
import UserItem from "@/components/UserItem/UserItem.vue";
@Component({
  components: { Scroller, UserItem }
})
export default class InsUserIner extends Vue {
  @Getter(GETTER_INS_USER_INFO_LIST)
  private insUserInfoList: any;
  @Getter(GETTER_CURRENT_USER_ID)
  private currentUserId: any;

  private clickItem(id: string) {
    this.$emit("clickItem", id);
  }

  get itemListHeight() {
    return 96 * this.insUserInfoList.length;
  }
}
